import React, { useEffect, useCallback } from 'react';
import cross from '../../assets/svg/dowload.svg';

const Modal = ({
  name,
  width,
  onClose,
  upShift,
  children,
  hideClose,
  // New props
  isDirty,
  confirmOnClose,
  modalType = "default"
}) => {
  // Helper function to handle closure
  const handleClose = useCallback(() => {
    // Confirmation dialog appears if both conditions are true:
    // 1. confirmOnClose prop is true
    // 2. isDirty prop is true
    if (confirmOnClose && isDirty) {
      const userConfirmed = window.confirm(
        'Are you sure you want to close? Any unsaved changes will be lost.'
      );
      if (!userConfirmed) return; // Stops closing if user clicks "Cancel"
    }
    onClose(); // Proceeds with closing if confirmed or if no confirmation needed
  }, [confirmOnClose, isDirty, onClose]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        handleClose(); // Uses same confirmation logic
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleClose]);

  // Handle click on the background overlay
  const handleBackgroundClick = (event) => {
    // Only close if clicking directly on the background overlay
    if (event.target === event.currentTarget) {
      handleClose();
    }
  };

  return (
    <div
      className="h-screen w-screen bg-[#0000002a] z-[9000] flex justify-center items-center fixed top-0 left-0"
      onClick={handleBackgroundClick}>
      <div
        className={`bg-white rounded-lg ${upShift ? 'h-[94%]' : 'h-fit'}`}
        style={{
          width: `${width}%`
        }}>
        {/* Head */}
        <div className="flex justify-between items-center px-6 py-4 bg-[#E9F5F6] rounded-t-lg">
          <span className="text-gray-700 font-semibold text-lg">{name}</span>
          {!hideClose && (
            <img
              src={cross}
              alt="Close modal"
              className="cursor-pointer hover:scale-110 transition-all duration-300"
              onClick={handleClose}
            />
          )}
        </div>

        {/* Body */}
        <div className="py-6 px-8 max-h-[85vh] overflow-y-auto"
          style={{
            overflow: modalType === "select-lead" ? "visible" : undefined
          }}
        >{children}</div>
      </div>
    </div>
  );
};

export default Modal;
